import { AxiosRequestConfig } from "axios";
import { fetchApi, version1 } from "../../Libs/Config/APIConfig";
import { BEARER_TOKEN } from "../../Libs/Utils/utils";

interface CustomAxiosRequestConfig<T = unknown> extends AxiosRequestConfig<T> {}
const AuthDataConfig: CustomAxiosRequestConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const apiHcpcsCodeList = async () => {
  const configWithAuth: CustomAxiosRequestConfig = {
    ...AuthDataConfig,
    headers: {
      ...AuthDataConfig.headers,
      Authorization: `Bearer ${BEARER_TOKEN}`,
    },
  };
  return fetchApi.get(`/api/${version1}/hcpcs_codes/`, configWithAuth);
};
